import { purchaseOrdersListingRoutes } from './features/purchase-orders-listing/purchase-orders-listing.routes';
import { purchaseOrderDetailsRoutes } from './features/purchase-order-details/purchase-order-details.routes';
export const purchaseOrdersRoutes = [
  {
    path: '/purchase-orders',
    name: 'purchase-orders',
    meta: {
      requiresAuth: true // all app paths requires authentication
    },
    component: () => import(/* webpackChunkName: "purchase-orders" */ './PurchaseOrders.vue'),
    children: [...purchaseOrdersListingRoutes, ...purchaseOrderDetailsRoutes]
  }
];
